import { API_URLS, customAxios } from "../config";

export const getQuotations = payload => customAxios.post(API_URLS.quotations, payload)
.catch(ex => ({data:{message : "Some error occured, Please try after sometime."}}));

// eslint-disable-next-line import/no-anonymous-default-export
export default {getQuotations}